export const globalConf=window.__CONFIG;export const globalData=window.__DATA;